import { withSafeSuspense } from '@calendly/safe-suspense'
import { lazy } from 'react'

// Share availability
const ShareAvailabilityContent = lazy(async () => {
  const loaded = await import('./shareComponents')
  return { default: loaded.ShareAvailability }
})
export const ShareAvailability = withSafeSuspense(ShareAvailabilityContent)

// Book Meeting
const BookMeetingContent = lazy(async () => {
  const loaded = await import('./shareComponents')
  return { default: loaded.BookMeeting }
})
export const BookMeeting = withSafeSuspense(BookMeetingContent)

// Send Email
const SendEmailContent = lazy(async () => {
  const loaded = await import('./shareComponents')
  return { default: loaded.SendEmail }
})
export const SendEmail = withSafeSuspense(SendEmailContent)

// Examples
const ExampleShareAvailabilityContent = lazy(async () => {
  const loaded = await import('./examples')
  return { default: loaded.ExampleShareAvailability }
})
export const ExampleShareAvailability = withSafeSuspense(ExampleShareAvailabilityContent)

const ExampleBookMeetingContent = lazy(async () => {
  const loaded = await import('./examples')
  return { default: loaded.ExampleBookMeeting }
})
export const ExampleBookMeeting = withSafeSuspense(ExampleBookMeetingContent)

const ExampleSendEmailContent = lazy(async () => {
  const loaded = await import('./examples')
  return { default: loaded.ExampleSendEmail }
})
export const ExampleSendEmail = withSafeSuspense(ExampleSendEmailContent)
